/* global ViewController */
var renewPasswordPortalController = new ViewController({
    directory : "views/portal",
    name: "renewPasswordPortal",
    container: "main",
    route: "portal-renew-pass"
}) ;

renewPasswordPortalController.prepareDataOnEnter = function(token, callback){
    this.api.public.getPortalPartnerByPasswordToken(token, function(err, partner){
        if(err){ return callback(err) ;}
        this.api.public.getLastTerms(function(err, terms){
            if(err){ return callback(err) ;}
            var data = {
                token: token,
                partner: partner,
                terms: terms
            } ;
            callback(null, data) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

renewPasswordPortalController.onValidate = function(){
    this.view.longTask(function(done){
        this.view.updateData() ;
        this.api.public.partnerRenewPassword(this.data.token, this.data.passwordNew, function(err){
            if(err){ 
                if(err === "EXPIRED"){
                    err = this.view.tr("portal.renewPasswordExpired") ;
                }
                return done(err) ;
            }
            done() ;
            this.view.info(this.view.tr("portal.renewPasswordSuccess"), function(){
                this.navigate("/portal") ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


module.exports = renewPasswordPortalController ;